module.exports = __webpack_public_path__ + "static/media/banner_m_07.ec0b4d1a.jpg";